var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-form",
        {
          ref: "form",
          model: {
            value: _vm.valid,
            callback: function($$v) {
              _vm.valid = $$v
            },
            expression: "valid"
          }
        },
        [
          _c(
            "div",
            { staticClass: "section-title mb-2" },
            [
              _c(
                "v-icon",
                { staticClass: "mr-2", attrs: { color: "primary" } },
                [_vm._v("mdi-identifier")]
              ),
              _c(
                "span",
                {
                  staticClass: "text-subtitle-1 font-weight-bold primary--text"
                },
                [_vm._v("Identificação")]
              )
            ],
            1
          ),
          _c("v-divider", { staticClass: "mb-4" }),
          _c(
            "v-row",
            { attrs: { dense: "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "2", md: "2" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      label: "ID",
                      readonly: "",
                      disabled: "",
                      "prepend-inner-icon": "mdi-key"
                    },
                    model: {
                      value: _vm.cartorio.id,
                      callback: function($$v) {
                        _vm.$set(_vm.cartorio, "id", $$v)
                      },
                      expression: "cartorio.id"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "3", md: "3" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      label: "Código IBGE",
                      readonly: "",
                      disabled: "",
                      "prepend-inner-icon": "mdi-map-marker"
                    },
                    model: {
                      value: _vm.cartorio.cd_ibge_comarca,
                      callback: function($$v) {
                        _vm.$set(_vm.cartorio, "cd_ibge_comarca", $$v)
                      },
                      expression: "cartorio.cd_ibge_comarca"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "2", md: "2" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      label: "Número",
                      readonly: "",
                      disabled: "",
                      "prepend-inner-icon": "mdi-numeric"
                    },
                    model: {
                      value: _vm.cartorio.nu_cartorio,
                      callback: function($$v) {
                        _vm.$set(_vm.cartorio, "nu_cartorio", $$v)
                      },
                      expression: "cartorio.nu_cartorio"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "5", md: "5" } },
                [
                  _c("v-text-field", {
                    directives: [
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: "XX.XXX.XXX/XXXX-##",
                        expression: "'XX.XXX.XXX/XXXX-##'"
                      }
                    ],
                    attrs: {
                      outlined: "",
                      dense: "",
                      label: "CNPJ",
                      rules: [_vm.rules.required, _vm.rules.validarCNPJ],
                      "prepend-inner-icon": "mdi-file-document"
                    },
                    model: {
                      value: _vm.cartorio.cnpj,
                      callback: function($$v) {
                        _vm.$set(_vm.cartorio, "cnpj", $$v)
                      },
                      expression: "cartorio.cnpj"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "8", md: "8" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      label: "Nome do Cartório",
                      rules: _vm.requiredRules,
                      "prepend-inner-icon": "mdi-office-building"
                    },
                    model: {
                      value: _vm.cartorio.nm_cartorio,
                      callback: function($$v) {
                        _vm.$set(_vm.cartorio, "nm_cartorio", $$v)
                      },
                      expression: "cartorio.nm_cartorio"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "4", md: "4" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      label: "Responsável pelo Tabelionato",
                      "prepend-inner-icon": "mdi-account"
                    },
                    model: {
                      value: _vm.cartorio.nm_responsavel_tabelionato,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.cartorio,
                          "nm_responsavel_tabelionato",
                          $$v
                        )
                      },
                      expression: "cartorio.nm_responsavel_tabelionato"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section-title mb-2 mt-4" },
            [
              _c(
                "v-icon",
                { staticClass: "mr-2", attrs: { color: "primary" } },
                [_vm._v("mdi-phone")]
              ),
              _c(
                "span",
                {
                  staticClass: "text-subtitle-1 font-weight-bold primary--text"
                },
                [_vm._v("Contato")]
              )
            ],
            1
          ),
          _c("v-divider", { staticClass: "mb-4" }),
          _c(
            "v-row",
            { attrs: { dense: "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "4", md: "4" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      label: "Telefone",
                      rules: _vm.requiredRules,
                      "prepend-inner-icon": "mdi-phone"
                    },
                    model: {
                      value: _vm.cartorio.telefone,
                      callback: function($$v) {
                        _vm.$set(_vm.cartorio, "telefone", $$v)
                      },
                      expression: "cartorio.telefone"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "8", md: "8" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      label: "E-mail",
                      rules: [_vm.rules.required, _vm.rules.email],
                      "prepend-inner-icon": "mdi-email"
                    },
                    model: {
                      value: _vm.cartorio.email,
                      callback: function($$v) {
                        _vm.$set(_vm.cartorio, "email", $$v)
                      },
                      expression: "cartorio.email"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section-title mb-2 mt-4" },
            [
              _c(
                "v-icon",
                { staticClass: "mr-2", attrs: { color: "primary" } },
                [_vm._v("mdi-map-marker")]
              ),
              _c(
                "span",
                {
                  staticClass: "text-subtitle-1 font-weight-bold primary--text"
                },
                [_vm._v("Endereço")]
              )
            ],
            1
          ),
          _c("v-divider", { staticClass: "mb-4" }),
          _c(
            "v-row",
            { attrs: { dense: "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "2", md: "2" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      label: "CEP",
                      rules: _vm.requiredRules,
                      "prepend-inner-icon": "mdi-mailbox"
                    },
                    model: {
                      value: _vm.cartorio.cep,
                      callback: function($$v) {
                        _vm.$set(_vm.cartorio, "cep", $$v)
                      },
                      expression: "cartorio.cep"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "5", md: "5" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      label: "Endereço",
                      rules: _vm.requiredRules,
                      "prepend-inner-icon": "mdi-road"
                    },
                    model: {
                      value: _vm.cartorio.endereco,
                      callback: function($$v) {
                        _vm.$set(_vm.cartorio, "endereco", $$v)
                      },
                      expression: "cartorio.endereco"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "2", md: "2" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      label: "Número",
                      rules: _vm.requiredRules
                    },
                    model: {
                      value: _vm.cartorio.endereco_numero,
                      callback: function($$v) {
                        _vm.$set(_vm.cartorio, "endereco_numero", $$v)
                      },
                      expression: "cartorio.endereco_numero"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "3", md: "3" } },
                [
                  _c("v-text-field", {
                    attrs: { outlined: "", dense: "", label: "Complemento" },
                    model: {
                      value: _vm.cartorio.complemento,
                      callback: function($$v) {
                        _vm.$set(_vm.cartorio, "complemento", $$v)
                      },
                      expression: "cartorio.complemento"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "3", md: "3" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      label: "Bairro",
                      rules: _vm.requiredRules,
                      "prepend-inner-icon": "mdi-home-city"
                    },
                    model: {
                      value: _vm.cartorio.bairro,
                      callback: function($$v) {
                        _vm.$set(_vm.cartorio, "bairro", $$v)
                      },
                      expression: "cartorio.bairro"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "5", md: "5" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      label: "Cidade",
                      rules: _vm.requiredRules,
                      "prepend-inner-icon": "mdi-city"
                    },
                    model: {
                      value: _vm.cartorio.nm_cidade,
                      callback: function($$v) {
                        _vm.$set(_vm.cartorio, "nm_cidade", $$v)
                      },
                      expression: "cartorio.nm_cidade"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "2", md: "2" } },
                [
                  _c("v-select", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      label: "UF",
                      rules: _vm.requiredRules,
                      items: _vm.listaUfs,
                      "prepend-inner-icon": "mdi-flag"
                    },
                    model: {
                      value: _vm.cartorio.cd_uf,
                      callback: function($$v) {
                        _vm.$set(_vm.cartorio, "cd_uf", $$v)
                      },
                      expression: "cartorio.cd_uf"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }